// source: template-project@7007a338a apps/backoffice/src/pages/onboarding-v2/growth-score/__fixtures__/growth-score.fixtures.ts (ADAPT: `searchBlocks` and `searchActions`, the words only)
// ADAPTED (owner rule: TP's onboarding is a prototype, we copy its look, never its data): TP's Search & AI "Check / You /
// Cohort" rows, agent checklist, data-vendor source lines and sentences were Shapermint sample figures, so none is kept. What
// stays is what each block MEANS. The scores come from the BFF's `searchBlocks`; the table rows are the BFF's `measured` rows
// for the block's check (none when it sent none); the three actions are ordered by the BFF's block scores, lowest first.
import type { SearchBlockKey } from '@/contracts/onboarding-session'

import type { Gap } from './growth-score.types'

export interface SearchBlockContent {
  gap: Gap
}

/** What each block asks, in words: no number, brand, vendor or claim about the brand. */
export const SEARCH_BLOCK_CONTENT: Record<SearchBlockKey, SearchBlockContent> = {
  seo: {
    gap: { lead: 'Do shoppers find you without searching for your name?', rest: "Searches that don't include your name are where new buyers can find you." },
  },
  sem: {
    gap: { lead: 'Do you hold your own name in paid search?', rest: 'Competitors can bid on searches for your brand name.' },
  },
  ai: {
    gap: { lead: 'Do AI assistants and AI search quote you?', rest: 'Assistants answer shopping questions from the pages they can read and cite.' },
  },
  agent: {
    gap: { lead: 'Can an AI agent find your products and pay?', rest: 'It depends on how readable your product data is and whether an agent can check out.' },
  },
}

/** A "Start with these" card: the area, a title and a line on why. One per block; the page shows the three lowest-scoring blocks. */
export type SearchAction = [area: string, title: string, body: string]

export const SEARCH_ACTIONS: Record<SearchBlockKey, SearchAction> = {
  seo: [
    'SEO',
    'Answer the questions shoppers ask',
    "Size guides and comparison pages answer the questions shoppers type in when they don't know you yet.",
  ],
  sem: ['SEM', 'Defend your brand name', 'A brand campaign keeps the visits from people who are already looking for you.'],
  ai: [
    'AI visibility',
    'Get quoted in AI answers',
    'Assistants answer shopping questions from the pages they can read. Publish pages that answer those questions clearly.',
  ],
  agent: [
    'Agent readiness',
    'Make your products readable to agents',
    'Keep your product data complete, with price and stock, so an AI agent can find your products and check out.',
  ],
}
